import { render, staticRenderFns } from "./MultiOrderableFormatListSelector.vue?vue&type=template&id=034460dc&scoped=true&"
import script from "./MultiOrderableFormatListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiOrderableFormatListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiOrderableFormatListSelector.vue?vue&type=style&index=0&id=034460dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034460dc",
  null
  
)

export default component.exports